import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import { RaceRangerIconMark } from '../components/branding/RaceRangerBrand';

function StartupOfflineScreen() {
  return (
    <div
      className="h-screen flex items-center justify-center"
      style={{ background: '#060d1a' }}
    >
      {/* Ambient glow */}
      <div
        className="absolute pointer-events-none"
        style={{
          top: '20%', left: '50%', transform: 'translateX(-50%)',
          width: '400px', height: '400px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(239,68,68,0.08) 0%, transparent 70%)',
          filter: 'blur(40px)',
        }}
      />

      <div
        className="relative w-full max-w-sm mx-4 rounded-2xl p-8 text-center"
        style={{
          background: 'rgba(15,25,41,0.9)',
          border: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
        }}
      >
        <div className="mb-4 flex justify-center">
          <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-2xl border border-white/10 bg-black/30">
            <RaceRangerIconMark className="h-10 w-10" />
          </div>
        </div>
        <div
          className="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-5"
          style={{
            background: 'rgba(239,68,68,0.12)',
            border: '1px solid rgba(239,68,68,0.25)',
          }}
        >
          <WifiOff className="h-6 w-6 text-red-400" />
        </div>

        <h2 className="text-base font-bold text-white mb-2">No Internet Connection</h2>
        <p className="text-sm text-gray-500 dark:text-slate-400 mb-7 leading-relaxed">
          Please connect to the Internet to use Fleet Manager.
        </p>

        <button
          className="inline-flex items-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold text-white transition-all hover:-translate-y-[1px]"
          style={{
            background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
            boxShadow: '0 4px 16px rgba(59,130,246,0.35)',
          }}
          onClick={() => window.location.reload()}
        >
          <RefreshCw className="h-4 w-4" />
          Retry
        </button>
      </div>
    </div>
  );
}

export default StartupOfflineScreen;
